export const droppableList = {
  props: {
    droppable: Boolean,
  },
  data() {
    return {
      dragOverIndex: null,
      showFirstPlaceholder: false,
      listDragCounter: 0,
      dragCounters: [],
    };
  },
  methods: {

    onDragOver(event) {
      event.preventDefault();
      event.stopPropagation();
    },

    onDragEnter(event, index) {
      event.preventDefault();
      event.stopPropagation();
      if( !this.droppable ) return;
      this.dragOverIndex = index;
      if( !this.dragCounters[index] ) {
        this.dragCounters[index] = 0;
      }
      this.dragCounters[index] += 1 ;
    },

    onDragLeave(event, index) {
      event.preventDefault();
      event.stopPropagation();
      if( !this.droppable ) return;
      if(this.dragCounters[index]) {
        this.dragCounters[index]--;
      }

      if(this.dragCounters[index] === 0 && index === this.dragOverIndex) {
        this.dragOverIndex = null;
        this.dragCounters = [];
      }
    },

    onDrop(event) {
      event.stopPropagation();
      if( !this.droppable ) return;
      this.$emit('on-drop', {event, index: this.dragOverIndex + 1});
      this.dragOverIndex = null;
      this.dragCounters = [];
      this.listDragCounter = 0;
      this.showFirstPlaceholder = false;
    },

    onListDragEnter(event) {
      event.preventDefault();
      event.stopPropagation();
      if( !this.droppable ) return;
      this.listDragCounter++;
      this.showFirstPlaceholder = true;
      this.dragOverIndex = null;
      this.dragCounters = [];
    },

    onListDragLeave(event) {
      event.preventDefault();
      event.stopPropagation();
      if( !this.droppable ) return;
      this.listDragCounter--;
      if(this.listDragCounter === 0) {
        this.showFirstPlaceholder = false;
      }
    },

    onDropList(event) {
      event.stopPropagation();
      if( !this.droppable ) return;
      this.$emit('on-drop', {event, index: 0});
      this.dragOverIndex = null;
      this.listDragCounter = 0;
      this.dragCounters = [];
      this.showFirstPlaceholder = false;
    }
  }
};

